import { CoreFilters } from '@/components/filters/core-filters';

export class CyclePcEventFilter extends CoreFilters {
  $filters;
  $list;
  listItem = '.events-item';
  $forShow;
  $allControl;
  specializations = [];
  translation = false;
  internal = false;
  all = true;

  constructor() {
    super();
    this.init();
  }

  init() {
    this.$filters = $('.pc-cycle-schedule-filter');

    if (!this.$filters || this.$filters.length === 0) return;

    this.$list = $('.events-list');
    this.$allControl = $('.pc-cycle-schedule-filter-all-control');

    this.initAllListeners();

    this.filterData();
  }

  initAllListeners() {
    this.$allControl.on('change', (e) => {
      const $t = $(e.currentTarget);

      if ($t.is('.pc-cycle-schedule-filter-all')) {
        this.all = $t.prop('checked');
        this.internal = false;
        this.translation = false;
      }

      if ($t.is('.pc-cycle-schedule-filter-internal')) {
        this.internal = $t.prop('checked');
        this.all = false;
        this.translation = false;
      }

      if ($t.is('.pc-cycle-schedule-filter-translation')) {
        this.translation = $t.prop('checked');
        this.all = false;
        this.internal = false;
      }

      this.filterData();
    });
  }

  filterData() {
    const $items = this.$list.find(this.listItem);
    $items.addClass('filter-hide').removeClass('filter-for-show');

    $items.each((i, el) => {
      const $t = $(el);
      let toShow = true;

      if (!this.all) {
        if (this.internal) {
          toShow = $t.data('internal');
        }

        if (this.translation) {
          toShow = $t.data('translation');
        }
      }

      if (toShow) $t.addClass('filter-for-show');
    });

    this.$forShow = this.$list.find(this.listItem + '.filter-for-show');

    this.showFiltered(this.$forShow, Infinity);
  }
}
